<template>
  <div class="row" v-if="carLikes?.length > 0">
    <div class="col-md-12">
      <div class="details-car-grid">
        <div class="details-slider-heading">
          <h3>العروض الشبيهه</h3>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="recommend-slider owl-carousel">
              <Carousel
                :wrap-around="true"
                :autoplay="3000"
                :settings="settings"
                :breakpoints="breakpoints"
              >
                <Slide v-for="item in carLikes" :key="item.id">
                  <div class="listing-item bike-list m-2">
                    <div class="listing-img">
                      <router-link :to="`/listing/${item.id}`">
                        <img
                          :src="
                            item.images[0]?.image ||
                            require('@/assets/img/cars/no-car.jpg')
                          "
                          class="img-fluid"
                          alt="car"
                        />
                      </router-link>
                    </div>
                    <div class="listing-content">
                      <div
                        class="listing-features d-flex justify-content-between"
                      >
                        <div class="list-rating">
                          <!-- مفيش تقييمات في الريسبونس، ممكن نشيلهم أو نعمل قيمة افتراضية -->
                          <!-- <div class="list-ratings">
                          <i class="fas fa-star filled me-1"></i>
                          <i class="fas fa-star filled me-1"></i>
                          <i class="fas fa-star filled me-1"></i>
                          <i class="fas fa-star filled me-1"></i>
                          <i class="fas fa-star"></i>
                          <span>0</span>
                        </div> -->
                          <div>
                            <span class="featured-text">{{
                              timeAgo(item.created_at)
                            }}</span>
                          </div>
                          <span class="featured-text"
                            >{{ item.brand?.name }} -
                            {{ item.model?.name }}</span
                          >
                        </div>
                        <div class="list-km">
                          <span class="km-count"
                            ><img
                              src="@/assets/img/icons/map-pin.svg"
                              alt="author"
                            />{{ item.city?.name }} - {{ item.district?.name }}
                          </span>
                        </div>
                      </div>
                      <div class="listing-details-group">
                        <ul>
                          <li>
                            <span
                              ><img
                                src="@/assets/img/icons/car-parts-05.svg"
                                alt="Manual"
                            /></span>
                            <p>&nbsp; {{ item.gear }}</p>
                          </li>
                          <li>
                            <span
                              ><img
                                src="@/assets/img/icons/car-parts-02.svg"
                                alt="18 KM"
                            /></span>
                            <p>&nbsp; {{ item.kilometers }}</p>
                          </li>
                          <li>
                            <span
                              ><img
                                src="@/assets/img/icons/car-parts-03.svg"
                                alt="Diesel"
                            /></span>
                            <p>&nbsp; {{ item.fuel_type }}</p>
                          </li>

                          <li>
                            <span
                              ><img
                                src="@/assets/img/icons/car-parts-05.svg"
                                alt="2018"
                            /></span>
                            <p>&nbsp; {{ item.year }}</p>
                          </li>
                        </ul>
                      </div>
                      <div class="listing-button">
                        <!-- <div class="listing-price">
                        <h6>{{ item.price }} <span>جنيه</span></h6>
                      </div> -->
                        <div class="listing-price">
                          <h6 v-if="item.rent_or_sale == 'rent'">
                            ${{ item.price?.daily }}
                            <span>/ يوم</span>
                          </h6>
                          <h6 v-else-if="item.rent_or_sale == 'installment'">
                            ${{ item.installment?.price }}
                          </h6>
                          <h6 v-else>${{ item.price }}</h6>
                        </div>
                        <div class="d-flex align-items-center">
                          <a
                            href="javascript:void(0)"
                            class="fav-icon"
                            @click="toggleSelected(item)"
                            :class="{ selected: item.is_fav }"
                          >
                            <i class="feather-heart"></i>
                          </a>
                          <router-link
                            :to="`/listing/${item.id}`"
                            class="btn btn-order"
                            >شوف تفاصيل</router-link
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </Slide>
                <template #addons></template>
              </Carousel>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Carousel, Navigation, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import { useFavoriteStore } from "@/stores/favorite";

export default {
  props: {
    carLikes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      breakpoints: {
        575: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        767: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        991: {
          itemsToShow: 3,
          snapAlign: "center",
        },
        1024: {
          itemsToShow: 3,
          snapAlign: "start",
        },
      },
    };
  },
  components: {
    Carousel,
    Slide,
    Navigation,
  },
  methods: {
    timeAgo(date) {
      if (!date) return "";
      const now = new Date();
      const created = new Date(date);
      const diff = Math.floor((now - created) / 1000);

      if (diff < 60) return "منذ ثوانٍ";
      if (diff < 3600) return `منذ ${Math.floor(diff / 60)} دقيقة`;
      if (diff < 86400) return `منذ ${Math.floor(diff / 3600)} ساعة`;
      if (diff < 2592000) return `منذ ${Math.floor(diff / 86400)} يوم`;
      if (diff < 31104000) return `منذ ${Math.floor(diff / 2592000)} شهر`;
      return `منذ ${Math.floor(diff / 31104000)} سنة`;
    },
  },
  setup() {
    const favoriteStore = useFavoriteStore();

    const toggleSelected = (item) => {
      favoriteStore.toggleFavorite(item.id);

      item.isSelected = !item.isSelected;
      item.is_fav = !item.is_fav;
    };

    return {
      toggleSelected,
    };
  },
};
</script>

<style scoped>
.img-fluid {
  height: 500px;
  object-fit: cover;
  border-radius: 8px;
}
/* .details-slider-heading {
  margin-bottom: 70px;
} */
</style>
